// MultiStepForm.js

import React, { useEffect, useState } from "react";
import axios from "../config/axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../components/Footer";
import { Textarea } from "@chakra-ui/react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import "jspdf-autotable";
import Logo from "../Assets/images/logo.png";
import { Vortex } from 'react-loader-spinner'

const steps = [
    {
        id: 1,
        options: [
            "3T MRI",
            "Dobutamine stress echocardiogram",
            "CT",
            "Echocardiogram bubble study",
            "X-ray",
            "Exercise stress echocardiogram",
            "Ultrasound",
            "24-hour ECG monitor",
            "Fluoroscopy",
            "48-hour ECG monitor",
            "ECG",
            "72-hour ECG monitor",
            "Echocardiogram",
            "7-day ECG monitor",
            "Exercise Stress ECG",
            "14-day ECG monitor",
            "24-hour BP monitor",
        ],
        field: "clinicalInfo",
        stepName: "Select Modality",
    },
    {
        id: 2,

        labels: [
            "Does the patient have a metal implant or pacemaker?",
            "Has the patient ever had an injury to the eye involving a metallic object?",
        ],
        fields: ["metalImplant", "eyeInjury",],
        stepName: "Safety",
    },
    {
        id: 3,
        /*  options: [
             "3T MRI",
             "Dobutamine stress echocardiogram",
             "CT",
             "Echocardiogram bubble study",
             "X-ray",
             "Exercise stress echocardiogram",
             "Ultrasound",
             "24-hour ECG monitor",
             "Fluoroscopy",
             "48-hour ECG monitor",
             "ECG",
             "72-hour ECG monitor",
             "Echocardiogram",
             "7-day ECG monitor",
             "Exercise Stress ECG",
             "14-day ECG monitor",
             "24-hour BP monitor",
         ], */
        labels: [
            "Does the patient have a metal implant or pacemaker?",
            "Has the patient ever had an injury to the eye involving a metallic object?",
        ],
        fields: ["metalImplant", "eyeInjury", "clinicalInfo",],
        stepName: "Summary",
    },
    {
        id: 4,
        stepName: "Finish",
    },
];

const MultiStepForm = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [formData, setFormData] = useState("");
    const [errors, setErrors] = useState({});
    const [id, setId] = useState("");
    const [rid, setRid] = useState("");
    const [loading, setLoading] = useState(false)
    const [url, setUrl] = useState(null);
    const [referralStatus, setReferralStatus] = useState(false)
    const [Referral, setReferrlchange] = useState();

    const [userData, setUserData] = useState({});

    /* const formattedDate = formData.date instanceof Date && !isNaN(formData.date)
        ? formatDate(formData.date)
        : ''; */
    const location = useLocation();
    const navigate = useNavigate();
    /* useEffect(() => {
       
    }); */
    useEffect(() => {
        const id = JSON.parse(sessionStorage.getItem("data"))?.userData._id;
        console.log(id);
        axios.get(`/users/${id}`).then((response) => {
            const userData = response.data?.data;
            console.log("response", userData);

            const status = JSON.parse(sessionStorage.getItem("data"))?.userData
                .statusId;
            const name = userData.name;
            console.log(name);

            if (userData.statusId === "inactive") {
                navigate("/");
                setTimeout(() => {
                    toast(
                        `Dear ${name} your is inactive. Please contact support for assistance`
                    );
                }, 500);
                return; // Exit the function after navigation
            }
        });
        setId(location?.state || "");
    }, [location]);
    const fetchData = async () => {
        try {
            if (id) {
                // Attempt to fetch patient data
                try {
                    const patientResponse = await axios.get(`patients/${id}`);
                    const patientData = patientResponse?.data?.data;
                    console.log("patient", patientData);
                    setFormData(patientData || {});
                    return; // Exit the function if patient data is successfully fetched
                } catch (patientError) {
                    console.error("Error fetching patient data:", patientError);
                }

                // Attempt to fetch referral data if patient data request fails
                try {
                    const referralResponse = await axios.get(`referrals/${id}`);
                    const referralData = referralResponse?.data?.data;
                    console.log("referral", referralData);
                    setReferralStatus(referralData.rf)
                    setFormData(referralData || {});
                } catch (referralError) {
                    console.error("Error fetching referral data:", referralError);
                    // Handle error or set default values if needed
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [id]);


    /* const fetchData = async () => {
        try {
            if (id) {
                const response = await axios.get(`patients/${id}`);
                const patientData = response?.data?.data;
                console.log("patient", patientData);
                setFormData(patientData || {});
            } else if (id) {
                const response2 = await axios.get(`referrals/${id}`);
                const referralData = response2?.data?.data;
                console.log("referral", referralData?.clinicalInfo);
                setFormData(referralData || {});
            }
        } catch (error) {
            console.error(error);
        }
    }; 

    useEffect(() => {
        fetchData();
    }, [id]);
     */
    // console.log("id", id);
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        localStorage.setItem(name, value);

        console.log("new form data", { name }, { value });

        setFormData((prevData) => ({
            ...prevData,
            [name]:
                type === "checkbox"
                    ? handleCheckboxChange(name, value, checked, prevData)
                    : value,
        }));

        console.log("checking", formData);
    };

    const handleCheckboxChange = (name, value, checked, prevData) => {
        const currentOptions = prevData[name] || [];

        if (checked) {
            return [...currentOptions, value];
        } else {
            return currentOptions.filter((option) => option !== value);
        }
    };

    const validateStep = () => {
        if (
            currentStep < 1 ||
            currentStep > steps.length ||
            !steps[currentStep - 1]
        ) {
            // Handle an invalid step index or undefined step
            return false;
        }

        const currentStepFields = steps[currentStep - 1].fields;
        const stepErrors = {};
        let isValid = true;
        currentStepFields?.forEach((field) => {
            const fieldValue = formData[field];

            // Check if the value is falsy or an empty array (for checkboxes)
            if (
                !fieldValue ||
                (Array.isArray(fieldValue) && fieldValue.length === 0)
            ) {
                stepErrors[field] = "Required field";
                isValid = false;
            }
        });
        if (formData.clinicalIndication === undefined || formData.clinicalIndication === "") {
            /* toast.error("Please enter any known clinical indication"); */
            toast.dismiss();
            toast("Please enter any known clinical indication");
            return false;
        }

        if (
            formData?.clinicalInfo?.length === undefined ||
            formData?.clinicalInfo?.length === 0
        ) {
            toast.dismiss();
            toast("Please select at least one option");
            return false;
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            [currentStep]: stepErrors,
        }));
        console.log("is valid", isValid);
        return isValid;
    };
    const updateStep = () => {
        setCurrentStep((prevStep) => prevStep + 1);
    };
    // const generatePdf = () => {
    //   const pdf = new jsPDF();

    //   // Add content to the PDF
    //   pdf.text("Patient Referral Form", 20, 20);
    //   pdf.text(`Patient Name: ${formData.name || ""}`, 20, 30);
    //   pdf.text(`Body Part: ${formData.bodyPart || ""}`, 20, 40);
    //   pdf.text(`Clinical Indication: ${formData.clinicalIndication || ""}`, 20, 50);

    //   // Additional content based on form data
    //   if (formData.clinicalInfo && formData.clinicalInfo.length > 0) {
    //     pdf.text("Selected Modalities:", 20, 60);
    //     formData.clinicalInfo.forEach((modality, index) => {
    //       pdf.text(`- ${modality}`, 30, 70 + index * 10);
    //     });
    //   }

    //   // Additional content based on safety data
    //   if (formData.metalImplant || formData.eyeInjury || formData.gender || formData.eGFR) {
    //     pdf.text("Safety Information:", 20, 90);

    //     if (formData.metalImplant) {
    //       pdf.text(`Metal Implant: ${formData.metalImplant}`, 30, 100);
    //     }

    //     if (formData.eyeInjury) {
    //       pdf.text(`Eye Injury: ${formData.eyeInjury}`, 30, 110);
    //     }

    //     if (formData.gender || formData.eGFR) {
    //       pdf.text("Pregnancy and eGFR:", 30, 120);

    //       if (formData.gender) {
    //         pdf.text(`Pregnancy: ${formData.gender}`, 40, 130);
    //       }

    //       if (formData.eGFR) {
    //         pdf.text(`eGFR: ${formData.eGFR}`, 40, 140);
    //       }
    //     }
    //   }

    //   // Save or download the PDF
    //   const pdfBlob = pdf.output("blob");
    //   formData.append("pdf", pdfBlob, "patient_form.pdf");
    // }
    const handleNextStep = async () => {
        // updateStep();
        if (validateStep()) {
            // Save data for the current step
            try {
                if (!location.state) {
                    toast("Patient is Not Found. Please Create a Patient First")
                    navigate("/patient_list")
                }
                const patientData = {
                    ...formData,
                    /* ref: "true" */
                }; // Copy formData to avoid mutating state directly
                if (currentStep === 2) {
                    // If the current step is Safety, handle the safety data
                    patientData.safety = {
                        // pacemaker: formData.metalImplant === "Yes" ? "Yes" : "No",
                        // eyeInjury: formData.eyeInjury === "Yes" ? "Yes" : "No",
                        pregnancy: formData.gender === "yes" ? "Yes" : "No", // Assuming 'yes' means pregnant
                        eGFR: formData.eGFR || null,
                    };
                }
                if (currentStep === 1) {
                    // If the current step is "Select Modality"
                    patientData.bodyPart = formData.bodyPart;
                    patientData.clinicalIndication =
                        formData.clinicalIndication;

                    // Show spinner here
                    setLoading(true);


                    // Move to next step after 5 seconds
                    setTimeout(() => {
                        updateStep();
                        setLoading(false);
                    }, 500);
                }

                // generatePdf()
            } catch (error) {
                // Handle API response errors
                console.error("Error saving data:", error);
                toast(error?.response?.data?.message || "An error occurred while saving data.");
            }
        }
    };





    /*  const handleNextStep = async () => {
         // updateStep();
         if (validateStep()) {
             // Save data for the current step
             try {
                 if (!location.state) {
                     toast("Patient is Not Found. Please Create a Patient First")
                     navigate("/patient_list")
                 }
                 const patientData = {
                     ...formData,
                 }; // Copy formData to avoid mutating state directly
                 if (currentStep === 2) {
                     // If the current step is Safety, handle the safety data
                     patientData.safety = {
                         // pacemaker: formData.metalImplant === "Yes" ? "Yes" : "No",
                         // eyeInjury: formData.eyeInjury === "Yes" ? "Yes" : "No",
                         pregnancy: formData.gender === "yes" ? "Yes" : "No", // Assuming 'yes' means pregnant
                         eGFR: formData.eGFR || null,
                     };
                 }
                 if (currentStep === 1) {
                     // If the current step is "Select Modality"
                     patientData.bodyPart = formData.bodyPart;
                     patientData.clinicalIndication =
                         formData.clinicalIndication;
 
                     
 
                     <Audio
                         height="80"
                         width="80"
                         radius="9"
                         loading={loading}
                         color="green"
                         ariaLabel="loading"
                         wrapperStyle
                         wrapperClass
                     />
 
                     setTimeout(() => {
                         updateStep();
                         setLoading(false)
 
                     }, 1000);
 
 
 
                 }
                 // generatePdf()
 
 
                 else {
 
                     // Handle API response errors
 
                     console.error("Error saving data:",);
                 }
 
             } catch (error) {
                 // Handle network or other errors
                 toast(error?.response?.data?.message);
                 console.error("Network error:", error);
             }
         }
     }; */

    /*     const handleNextStep = async () => {
            // updateStep();
            if (validateStep()) {
                // Save data for the current step
                try {
                    const patientData = { ...formData }; // Copy formData to avoid mutating state directly
                    if (currentStep === 2) {
                        // If the current step is Safety, handle the safety data
                        patientData.safety = {
                            pacemaker: formData.metalImplant === "Yes" ? "Yes" : "No",
                            eyeInjury: formData.eyeInjury === "Yes" ? "Yes" : "No",
                            pregnancy: formData.gender === "yes" ? "Yes" : "No", // Assuming 'yes' means pregnant
                            eGFR: formData.eGFR || null,
                        };
                    }
                    if (currentStep === 1) {
                        // If the current step is "Select Modality"
                        patientData.bodyPart = formData.bodyPart;
                        patientData.clinicalIndication = formData.clinicalIndication;
                    }
                    // generatePdf()
                    const response = await axios.patch(`patients/${id}`, patientData);
                    // Check for success status in your API response
                    if (response?.data?.status === 200 || 201) {
                        toast("Patient updated successfully");
                        updateStep();
                    } else {
                        // Handle API response errors
                        toast(response?.data?.message);
                        console.error("Error saving data:", response?.data?.error);
                    }
                } catch (error) {
                    // Handle network or other errors
                    toast(error?.response?.data?.message);
                    console.error("Network error:", error);
                }
            }
        }; */
    const handlePreviousStep = () => {
        setCurrentStep((prevStep) => prevStep - 1);
    };

    const handleCancel = () => {
        navigate("/all_patient");
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateStep()) {
            // Perform additional validation or submit the data to a server
            console.log("Form submitted:", formData);
        }
    };
    const handleInputTextChange = (name, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleSelectChange = (name, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleConfirm = async () => {
        setLoading(true);

        try {
            console.log("cc", Referral)

            const data = {

                ...Referral,
                rf: "false"
            }
            console.log("iiii", rid)
            const response1 = await axios.patch(`referrals/${rid} `, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log(response1);
            // toast("PDF generated successfully!");
            setTimeout(() => {
                toast("A copy of the referral has been sent to your email");
                updateStep();
                setLoading(false);
            }, 500);

            /*  setTimeout(() => {
                 toast("A copy of the referral has been sent to your email");
             }, 500);
 
             setTimeout(() => {
                 updateStep();
                 setLoading(false);
             }, 50); */
        } catch (error) {
            console.error("Axios Error:", error);
            // Handle specific error cases if needed
            if (error.response) {
                // The request was made and the server responded with a status code
                console.error("Response Data:", error.response.data);
                console.error("Status Code:", error.response.status);
            } else if (error.request) {
                // The request was made but no response was received
                console.error("No response received:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.error("Request Error:", error.message);
            }
            // Display an error message to the user
            toast("An error occurred while processing your request. Please try again later.");
        }

        /*  let response1;
 
 
         response1 = await axios.patch(`referrals/${id} `, data, {
             headers: {
                 "Content-Type": "multipart/form-data",
             },
         });
 
         console.log(response1)
 
 
 
 
 
         toast("Referral created Successfully!");
 
         setTimeout(() => {
             toast("A copy of the referral has been sent to your email");
         }, 1000);
 
         updateStep();
     } */
    }







    /* } catch (error) {
    // Handle network errors or other unexpected issues
    console.error("Error submitting form:", error);
     
    updateStep();
    } */




    /*    function formatDate(dateString) {
           const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
           const date = new Date(dateString);
           return date.toLocaleDateString('en-GB', options);
       } */
    /* function getCurrentDate(dateString) {
       const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
       const currentDate = new Date(dateString); // Use the provided date string
       return currentDate.toLocaleDateString('en-GB', options);
    }  */


    function formatDate(dateString) {
        // Create a Date object from the ISO date string
        const date = new Date(dateString);

        // Extract the year, month, and day components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(date.getDate()).padStart(2, '0');

        // Concatenate the components to form the formatted date string
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    }

    // Example usage:

    /*  const handleEdit = (rid) => {
         console.log(rid)
         navigate("/refer_patient", {
             state: rid,
     
         }
         );
         //        setCurrentStep((prevStep) => prevStep - 2); // Decrement the current step
          //         navigate("/refer_patient", {
              //    state: { patientId: id }, // Pass the patient ID as part of the state
      
            //  }); 
         console.log(referralStatus)
     
         console.log("WOrking")
     }; */
    const handleEdit = (rid) => {
        console.log(rid);
        setCurrentStep((prevStep) => prevStep - 2);
        navigate("/refer_patient", {
            state: rid,
        });
        console.log(referralStatus);
        console.log("Working");
    };
    ;
    const handleSendEmail = async () => {
        let patchResponse;


        try {
            if (
                formData.mobility === undefined ||
                formData.eyeInjury === undefined ||
                formData.metalImplant === undefined ||
                formData.pregnancyStatus === undefined ||
                formData.pregnancyStatus.trim() === ""
            ) {
                toast.error("Please answer all questions to proceed");
            } else {
                setLoading(true);
                const userId = JSON.parse(sessionStorage.getItem("data"))?.userData?._id;
                const response = await axios.get(`/users/${userId}`);
                const userData = response?.data?.data;

                setUserData(userData);

                if (userData?.jobTitle === "") {
                    toast("Please fill out all required fields to continue");
                    navigate("/profile");
                } else {
                    const name = JSON.parse(sessionStorage.getItem("data"))?.userData?.name;
                    const pdf = new jsPDF();

                    // Logo
                    const logo = new Image();
                    logo.src = Logo; // Ensure that Logo is properly defined and accessible

                    pdf.addImage(logo, 10, 9, 80, 14);
                    pdf.setFontSize(16);
                    pdf.setFont("bold");
                    // pdf.setFont("normal");

                    // Contacts
                    pdf.setFontSize(11);
                    pdf.setFont("bold");
                    pdf.text("Telephone:", 120, 16);
                    pdf.text("0207 467 6190", 138, 16);
                    pdf.text("Email:", 120, 23);
                    pdf.text("bookings@umegroup.com", 131, 23);
                    pdf.text("17 Harley Street, London W1G 9QH", 120, 30); //

                    // Title
                    pdf.setFontSize(28);
                    pdf.setFont("bold");
                    pdf.text("Imaging Referral Form", 65, 44); // Adjusted Y-coordinate to 51

                    //table
                    autoTable(pdf, {
                        startY: 48,
                        head: [
                            ["Patient details", `Date of referral: ${formatDate(formData.createdAt)}`],
                        ],
                        body: [
                            [
                                {
                                    content: `Title: ${formData.title}`,
                                    styles: { cellWidth: "auto" },
                                },
                                {
                                    content: `Address: ${formData.address}`,
                                    styles: { cellWidth: "auto" },
                                },
                            ],
                            [
                                {
                                    content: `First name: ${formData.firstName}`,
                                    styles: { cellWidth: "auto" },
                                },

                                {
                                    content: `Postcode: ${formData.postalCode}`,
                                    styles: { cellWidth: "auto" },
                                },
                            ],

                            [
                                {
                                    content: `Last name: ${formData.lastName}`,
                                    styles: { cellWidth: "auto" },
                                },
                                {
                                    content: `Telephone: ${formData.phoneNumber}`,
                                    styles: { cellWidth: "auto" },
                                },
                            ],

                            [
                                {
                                    content: `DOB: ${formatDate(formData.dob)}`,
                                    styles: { cellWidth: "auto" },
                                },
                                {
                                    content: `Email: ${formData.email}`,
                                    styles: { cellWidth: "auto" },
                                },
                            ],



                            [

                                {
                                    content: `Gender: ${formData.gender !== "Prefer Not to Say" ? formData.gender : ""}`,
                                    styles: { cellWidth: "auto" },
                                },
                                {
                                    content: `Payee: ${formData.payment}`,
                                    styles: { cellWidth: "auto" },
                                },
                            ],

                            [
                                {
                                    content: `Mobility: ${formData.mobility || " "}`,
                                    styles: { cellWidth: "auto" },
                                },


                                {
                                    content: `Insurance company: ${formData.provider || " "}`,
                                    styles: { cellWidth: "auto" },
                                },



                            ],

                            [
                                {
                                    content: `Pregnancy: ${formData.pregnancyStatus || " "}`,
                                    styles: { cellWidth: "auto" },
                                },
                                {
                                    content: `Policy number: ${formData.policyNumber || " "}`,
                                    styles: { cellWidth: "auto" },
                                },


                            ],
                            // ...
                        ],
                        columnStyles: {
                            0: { cellWidth: "auto" }, // Adjust column width for all columns
                            1: { cellWidth: "auto" }, // Adjust column width for all columns
                        },
                        headStyles: {
                            lineWidth: 0.5, // Border line for header
                        },
                        bodyStyles: {
                            lineWidth: 0.5, // Border line for body
                        },
                    });

                    let arr = [];

                    // Check if formData.clinicalInfo is defined before iterating over it
                    if (formData.clinicalInfo?.length) {
                        formData.clinicalInfo.forEach((items, index) => {
                            const design = {
                                content: items,
                                styles: { cellWidth: 5 },
                            };
                            arr.push(design);
                        });
                    } else {
                        console.error(
                            "formData.clinicalInfo is undefined or empty."
                        );
                    }


                    const headerRow = "Clinical Indication";

                    autoTable(pdf, {
                        startY: 140,
                        head: [["Clinical Indication"]],
                        body: [

                            [

                                {
                                    content: `${formData.clinicalIndication || " "}`,
                                    styles: { cellWidth: "auto", cellPadding: 5 },
                                }
                            ],
                        ],
                        headStyles: {
                            lineWidth: 0.5, // Border line for header
                        },
                        bodyStyles: {
                            lineWidth: 0.5, // Border line for body
                        },
                    });

                    const arrContent2 = arr.reduce((result, item) => {
                        if (
                            item.content != "3T MRI" ||
                            item.content != "CT" ||
                            item.content != "X-ray" ||
                            item.content != "Ultrasound" ||
                            item.content != "Fluoroscopy" ||
                            item.content != "ECG" ||
                            item.content != "Echocardiogram" ||
                            item.content != "Exercise Stress" ||
                            item.content != "24-BP Monitor" ||
                            item.content != "Echocardiogram bubble study" ||
                            item.content != "Exercise stress echocardiogram" ||
                            item.content != "24-hour ECG Monitor" ||
                            item.content != "48-hour ECG Monitor" ||
                            item.content != "72-hour ECG Monitor" ||
                            item.content != "7-day ECG Monitor" ||
                            item.content != "14-day ECG Monitor"
                        ) {
                            result.push([item.content]);
                        }
                        return result;
                    }, []);

                    // Remove duplicates and create an array of unique elements
                    const uniqueContent = Array.from(new Set(arrContent2));

                    // Split the unique content into four variables
                    const chunkSize = 3;
                    const variables = [];
                    const totalCells = uniqueContent.length;

                    for (let i = 0; i < totalCells; i += chunkSize) {
                        const variable = uniqueContent.slice(i, i + chunkSize);
                        variables.push([...variable]);
                    }



                    autoTable(pdf, {
                        startY: 113,
                        head: [["Diagnostic tests", "", ""]],
                        body: variables.map(row => {
                            // Add bullet points to each element in the row
                            return row.map(cell => {
                                return { content: `• ${cell}`, styles: { fontSize: 10 } };
                            });
                        })
                    });


                    console.log(formData)
                    autoTable(pdf, {
                        startY: 167,
                        head: [["Contrast investigations"]],
                        body: [
                            [
                                {
                                    content:
                                        "For patients above 65 years of age or with any known problems with kidney function, serum creatinine level or eGFR must be available prior to imaging.",
                                    styles: { cellWidth: "auto" },
                                },
                            ],
                            [
                                {
                                    content: `Serum creatinine / eGFR reading: ${formData.eGFR || " "}                            Date taken: ${formData.date ? formatDate(formData.date) : " "}`,



                                    styles: { cellWidth: "auto" },
                                },
                            ],
                        ],
                        headStyles: {
                            lineWidth: 0.5, // Border line for header
                        },
                        bodyStyles: {
                            lineWidth: 0.5, // Border line for body
                        },
                    });

                    console.log("meta implement", formData.metalImplant);

                    autoTable(pdf, {
                        startY: 197,
                        head: [["Safety check"]],
                        body: [
                            [
                                {
                                    content: `Cardiac pacemakers, artificial heart valves, cochlear implants, cerebral aneurysm clips are contra-indicated for MRI`,
                                    styles: { cellWidth: "auto" },
                                },
                            ],
                            [
                                {
                                    content: `Does the patient have a metal implant or pacemaker ? ${formData.metalImplant || " "
                                        } `,
                                    styles: { cellWidth: "auto" },
                                },
                            ],
                            [
                                {
                                    content: `Has the patient ever had an injury to the eye involving a metallic object ? ${formData.eyeInjury || " "} `,
                                    styles: { cellWidth: "auto" },
                                },
                            ],
                        ],

                        headStyles: {
                            lineWidth: 0.5, // Border line for header
                        },
                        bodyStyles: {
                            lineWidth: 0.5, // Border line for body
                        },
                    });
                    autoTable(pdf, {
                        startY: 234,
                        head: [["Referring clinician’s details"]],
                        body: [
                            [
                                {
                                    content: `Referrer name: ${userData.name}                                      Date:  ${formatDate(formData.createdAt)} `,

                                    styles: { cellWidth: "auto", },
                                },
                            ],



                            [
                                {
                                    content: `GMC number: ${userData.registrationNumber}                                                   Secretary Telephone: ${userData.secretaryTelephone} `,

                                    styles: { cellWidth: "auto" },
                                },
                            ],

                        ],
                        headStyles: {
                            lineWidth: 0.5, // Border line for header
                        },
                        bodyStyles: {
                            lineWidth: 0.5, // Border line for body
                        },
                    });
                    console.log("ss",)
                    const pdfBlob = pdf.output("blob");
                    const pdfFile = new File([pdfBlob], "patient_form.pdf");




                    const data = {
                        rf: "true",
                        secretaryEmail: userData.secretaryEmail,
                        secretaryName: userData.secretaryName,

                        secretaryTelephone: userData.secretaryTelephone,


                        payment: formData.payment,
                        paymentMethod: formData.paymentMethod,

                        provider: formData.provider,
                        address: formData.address,
                        postalCode: formData.postalCode,
                        city: formData.city,
                        dob: formData.dob,
                        date: formData.date,
                        gender: formData.gender,
                        phoneNumber: formData.phoneNumber,
                        policyNumber: formData.policyNumber,

                        email: formData.email,
                        title: formData.title,
                        firstName: formData.firstName,
                        lastName: formData.lastName,
                        consultant: formData.consultant,
                        clinicalIndication: formData.clinicalIndication,
                        clinicalInfo: formData.clinicalInfo,
                        eGFR: formData.eGFR,
                        metalImplant: formData.metalImplant,
                        eyeInjury: formData.eyeInjury,
                        date: formData.date,
                        createdAt: formData.createdAt,
                        patient: formData._id,
                        mobility: formData.mobility,
                        pregnancyStatus: formData.pregnancyStatus,
                        pending: "true",

                        pdfURL: formData.pdfURL,
                        pdf: pdfFile,


                    };


                    console.log("referraldata:", data)


                    const patient = formData._id;
                    let response1;
                    console.log("ridd:", id)
                    if (location?.state) {
                        if (referralStatus === true) {
                            console.log("Making POST request...")
                            response1 = await axios.patch(`referrals/${id} `, data, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            });

                        } else {
                            console.log("Making PATCH request...")

                            response1 = await axios.post("referrals/", data, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            });


                        }
                        console.log("rfff", response1.data.data)
                        setReferrlchange(response1.data.data)





                        // Move to next step after 5 seconds
                        setTimeout(() => {
                            updateStep();
                            setLoading(false);
                        }, 500);







                    } else {
                        toast("Patient is Not Found. Please Create a Patient First")
                        navigate("/patient_list")
                    }








                    /*       updateStep(); */






                    /* else {
                        response1 = await axios.post(`referrals / ${ id } `, data, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        });
                        toast("A copy of the referral has been sent to your email");
                        updateStep();
         
                    } */
                    console.log("datarrr", response1?.data?.data._id)
                    setRid(response1?.data?.data._id)
                    setUrl(response1?.data?.data.pdfURL)
                    console.log("formData", formData)

                    /*  else {
                        response1 = await axios.patch(`referrals / ${ id } `, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        });
                        console.log("testing2:", response1);
                        toast("A copy of the referral has been sent to your email");
                        updateStep();
         
                    } */

                    // Check for success status in your API response


                    /* 
                                    const response3 = await axios.get(`referrals /? consultant = ${ userId } `);
                                    const referrals = response3?.data?.data;
                                    console.log("ref:", referrals);
                                    const matchedPatient = referrals.filter((referral) => referral.consultant._id === user._id);
                                    console.log("rid", matchedPatient._id)
                                    const ptotal = await axios.get(`patients /? consultant = ${ userId } `);
                                    const pts = ptotal?.data?.data;
                                    console.log("pet:", pts); */

                    /*  const matchedPatient34 = referrals.filter((referral) => referral.clinicalIndication === pts.clinicalIndication);
                     console.log("dddd", matchedPatient34)
                     console.log("idddddddd", matchedPatient34._id) */
                    /*                 const patient = formData._id;
                     */
                    /*    const patchResponse = await axios.patch(
                            `patients / ${ id } `, {
                            formData, patient
                        }
                        );
                        console.log("Response from PATCH request:", patchResponse);
                        updateStep(); */
                    // Check if the patient data update was successful
                    /*       if (patchResponse?.status === 200) {
                              // Proceed to send email
                              const emailResponse = await axios.post("/referrals/sendmail", {
                                  pdfURL: formData?.pdfURL,
                                  id: formData?._id,
                                  name: `${ formData?.firstName || "" } ${ formData?.lastName || "" } `,
                              });
          
                              // Check for success status in your API response
                              if (emailResponse?.status === 200) {
                                  toast("A copy of the referral has been sent to your email");
                                  console.log("Email sent successfully");
                                  updateStep();  // Assuming this is a function to move to the next step
          
                              } else {
                                  // Handle API response errors for email sending
                                  toast(emailResponse?.data?.message || "Error sending email");
                                  console.error("Error sending email:", emailResponse?.data?.error || emailResponse?.statusText);
                              }
                          } else {
                              // Handle API response errors for patient data update
                              toast(patchResponse?.data?.message || "Error updating patient data");
                              console.error("Error updating patient data:", patchResponse?.data?.error || patchResponse?.statusText);
                          } */


                }
            }
        } catch (error) {
            // Handle network or other errors
            toast("An error occurred while processing the request");
            console.error("Network error:", error);

        }



    };

    /*   const handleSendEmail = async () => {
          try {
     
     
              if (
                  formData.eyeInjury === undefined ||
                  formData.metalImplant === undefined ||
                  formData.pregnancyStatus === undefined ||
                  formData.pregnancyStatus.trim() === ""
              ) {
                  toast.error("Please answer all questions to proceed");
              } else {
                  // All conditions are met, proceed with Axios request
                  const emailResponse = await axios.post("/patients/sendmail", {
                      pdfURL: formData?.pdfURL,
                      id: formData?._id,
                      name: `${ formData?.firstName || "" } ${ formData?.lastName || "" } `,
                  });
     
                  // Check for success status in your API response
                  if (emailResponse?.status === 200) {
                      toast("A copy of the referral has been sent to your email");
                      console.log(formData);
                      updateStep();
                  } else {
                      // Handle API response errors
                      toast(emailResponse?.data?.message || "Error sending email");
                      console.error("Error sending email:", emailResponse?.data?.error || emailResponse?.statusText);
                  }
                  const patchResponse = await axios.patch(
                      `patients / ${ id } `,
                      formData
                      ,
                  );
                  console.log("hh", patchResponse);
              }
          } catch (error) {
              // Handle network or other errors
              toast("An error occurred while sending the email");
              console.error("Network error:", error);
          }
      }; */

    /*  const handleSendEmail = async () => {
         try {
             const response = await axios.patch(
                 `patients / ${ id } `,
                 formData
             );
             console.log("hh", response)
             if (
                 formData.eyeInjury === undefined ||
                 formData.metalImplant === undefined ||
                 formData.pregnancyStatus === undefined ||
                 formData.pregnancyStatus.trim() === ""
             ) {
                 toast.error("Please answer all questions to proceed");
             } else {
                 // All conditions are met, proceed with Axios request
                 const response = await axios.post("/patients/sendmail", {
                     pdfURL: formData?.pdfURL,
                     id: formData?._id,
                     name: `${ formData?.firstName || "" } ${ formData?.lastName || "" } `,
                 });
     
                 // Check for success status in your API response
                 if (response?.status === 200) {
                     toast("A copy of the referral has been sent to your email");
                     console.log(formData);
                     updateStep();
                 } else {
                     // Handle API response errors
                     toast(response?.data?.message || "Error sending email");
                     console.error("Error sending email:", response?.data?.error || response?.statusText);
                 }
             }
         } catch (error) {
             // Handle network or other errors
             toast("An error occurred while sending the email");
             console.error("Network error:", error);
         }
     }; */

    /*  const handleSendEmail = async () => {
     
         try {
             if (formData.eyeInjury === undefined || formData.metalImplant === undefined) {
                 toast.error("Please answer both Yes/No questions to proceed");
             } else {
                 // Both conditions are met, proceed with Axios request
                 const response = await axios.post("/patients/sendmail", {
                     pdfURL: formData?.pdfURL,
                     id: formData?._id,
                     name: `${ formData?.firstName || "" } ${ formData?.lastName || "" } `,
                 });
     
                 // Check for success status in your API response
                 if (response?.status === 200) {
                     toast("A copy of the referral has been sent to your email");
                     console.log(formData);
                     updateStep();
                 } else {
                     // Handle API response errors
                     toast(response?.data?.message || "Error sending email");
                     console.error("Error sending email:", response?.data?.error || response?.statusText);
                 }
             }
         } catch (error) {
             // Handle network or other errors
             toast("An error occurred while sending the email");
             console.error("Network error:", error);
         }
     
         
     }; */

    /* const handleSendEmail = async () => {
        try {
            if (
                formData.eyeInjury === undefined ||
                formData.metalImplant === undefined
            ) {
                toast.error("Please answer both Yes/No questions to proceed");
            } else {
                const response = await axios.post("/patients/sendmail", {
                    pdfURL: formData?.pdfURL,
                    id: formData?._id,
                    name: formData?.firstName + " " + formData?.lastName,
                });
                if (response?.status === 200) {
                    toast("A copy of the referral has been sent to your email");
                    updateStep();
                } else {
                    // Handle API response errors
                    toast(response?.data?.message);
                    console.error("Error saving data:", response?.data?.error);
                }
            }
        } catch { }
     
        // try {
        //   const response = await axios.post("/patients/sendmail", {
        //     pdfURL: formData?.pdfURL,
        //     id: formData?._id,
        //     name: formData?.firstName + " " + formData?.lastName,
        //   });
        //   if (response?.status === 200) {
        //     toast("Email Sent to Admin");
        //     updateStep();
        //   }
        // } catch (error) {
        //   console.log(error);
        //   toast(error?.response?.data?.message);
        // }
    }; */
    return (


        <>
            {loading ? (
                <>
                    <div className="p-36  flex justify-center items-center mt-20">
                        <Vortex
                            className="animate-bounce"
                            visible={true}
                            height="80"
                            width="80"
                            loading={loading}
                            ariaLabel="vortex-loading"
                            wrapperStyle={{}}
                            wrapperClass="vortex-wrapper"
                            colors={['red', 'green', 'blue', 'yellow', 'orange', 'purple']}
                        />
                        <h2 className=" flex font-bold animate-bounce text-[#003942] " >
                            Saving Referral
                            <span className="animate-bounce text-[#003942]" style={{ animationDelay: '0.2s' }}> . </span>
                            <span className="animate-bounce text-[#003942]" style={{ animationDelay: '0.6s' }}> . </span>
                            <span className="animate-bounce text-[#003942]" style={{ animationDelay: '0.9s' }}> . </span>
                        </h2>

                    </div>
                </>
            ) : (
                <div>
                    {
                        window.innerWidth < 500 ? (
                            <div className="text-center text-white p-4 bg-red-500">
                                Sorry! this portal is only operatable through desktop devices.
                            </div>
                        ) : (


                            <div
                                className="mx-auto my-5"
                                style={{ width: "80%", backgroundColor: "white" }}

                            >

                                <ToastContainer />
                                <div className="mb-4 w-full mt-5">

                                    <div className="flex space-x-2 w-full">
                                        {steps.map((step, index) => (
                                            <React.Fragment key={step.id}>
                                                {index > 0 && (
                                                    <div
                                                        className="flex items-center"
                                                        style={{ flex: "0.6 1" }}
                                                    >
                                                        <div className="flex-1 h-0.5 bg-gray-300"></div>
                                                    </div>
                                                )}
                                                <div
                                                    className={`flex items-center justify-between ps-2  py-1 border -black rounded-full ${step.id === currentStep
                                                        ? "font-lg hover:scale-105 transition-transform duration-300 transform origin-center"
                                                        : "opacity-50 cursor-not-allowed"
                                                        } `}
                                                >
                                                    <span
                                                        className={`border-2 rounded-full p-1 px-3 ${step.id === currentStep
                                                            ? "bg-[#2CA1C8]"
                                                            : "bg-[#D0D5DD]"
                                                            } `}
                                                    >
                                                        {step.id}
                                                    </span>{" "}
                                                    <span className="text-clip inline-flex justify-end px-4">
                                                        {step?.stepName}
                                                    </span>
                                                </div>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    {steps.map((step, index) => (
                                        <div
                                            key={step.id}
                                            className={currentStep === step.id ? "" : "hidden"}
                                        >
                                            {currentStep !== steps.length && (



                                                <h2 className="text-2xl font-bold mb-4">
                                                    {step.stepName}



                                                </h2>



                                            )}
                                            <div
                                                className={
                                                    step.stepName === "Select Modality"
                                                        ? "grid grid-cols-2 gap-2"
                                                        : ""
                                                }
                                            >
                                                {step.options &&
                                                    step.options.map((option, optionIndex) => (
                                                        <div key={optionIndex} className="mb-4">
                                                            <div className="flex items-center space-x-2">
                                                                <input
                                                                    type="checkbox"
                                                                    name={step.field}
                                                                    value={option}
                                                                    id={option}
                                                                    checked={
                                                                        formData[step.field] &&
                                                                        formData[
                                                                            step.field
                                                                        ].includes(option)
                                                                    }
                                                                    onChange={handleInputChange}
                                                                    className="mr-2 w-5 h-5"
                                                                    style={{
                                                                        backgroundColor:
                                                                            formData[
                                                                                step.field
                                                                            ] &&
                                                                                formData[
                                                                                    step.field
                                                                                ].includes(option)
                                                                                ? "#F5F4F0"
                                                                                : "inehrit",
                                                                    }}

                                                                />
                                                                <label
                                                                    className="block text-base font-medium text-gray-700"
                                                                    htmlFor={option}
                                                                >
                                                                    {option}
                                                                </label>
                                                            </div>
                                                            {errors[currentStep] &&
                                                                errors[currentStep][
                                                                step.field
                                                                ] && (
                                                                    <p className="text-red-500 text-sm mt-1">
                                                                        {
                                                                            errors[currentStep][
                                                                            step.field
                                                                            ]
                                                                        }
                                                                    </p>
                                                                )}
                                                        </div>
                                                    ))}

                                                {step.stepName === "Safety" && (
                                                    <>
                                                        <p className="font-semibold my-2">
                                                            1. Safety check (as recommended by
                                                            the MHRA, the referring clinician is
                                                            required to assess patient safety
                                                            for MRI scans).
                                                        </p>
                                                        <p className="my-2">
                                                            Cardiac pacemakers, artificial heart
                                                            valves, cochlear implants, cerebral
                                                            aneurysm clips are contra-indicated
                                                            for MRI.
                                                        </p>
                                                    </>
                                                )}
                                                {step.stepName === "Safety" && (
                                                    <>
                                                        {step.labels &&
                                                            step.labels.map(
                                                                (label, labelIndex) => (
                                                                    <div
                                                                        key={labelIndex}
                                                                        className="mb-4 flex"
                                                                    >
                                                                        <label className="block text-sm font-medium text-gray-700 flex-1">
                                                                            {label}<span className="text-red-500">*</span>
                                                                        </label>
                                                                        <div className="flex items-center space-x-2">
                                                                            <label className="flex items-center mr-2">
                                                                                <input
                                                                                    type="radio"
                                                                                    name={
                                                                                        step
                                                                                            .fields[
                                                                                        labelIndex
                                                                                        ]
                                                                                    }
                                                                                    value="Yes"
                                                                                    checked={
                                                                                        formData[
                                                                                        step
                                                                                            .fields[
                                                                                        labelIndex
                                                                                        ]
                                                                                        ] ===
                                                                                        "Yes"
                                                                                    }
                                                                                    onChange={
                                                                                        handleInputChange
                                                                                    }
                                                                                />
                                                                                <span className="ml-1">
                                                                                    Yes
                                                                                </span>
                                                                            </label>
                                                                            <label className="flex items-center">
                                                                                <input type="radio"
                                                                                    name={
                                                                                        step
                                                                                            .fields[
                                                                                        labelIndex
                                                                                        ]
                                                                                    }
                                                                                    value="No"
                                                                                    checked={
                                                                                        formData[
                                                                                        step
                                                                                            .fields[
                                                                                        labelIndex
                                                                                        ]
                                                                                        ] ===
                                                                                        "No"
                                                                                    }
                                                                                    onChange={
                                                                                        handleInputChange
                                                                                    }
                                                                                />
                                                                                <span className="ml-1">
                                                                                    No
                                                                                </span>
                                                                            </label>
                                                                        </div>
                                                                        {errors[currentStep] &&
                                                                            errors[currentStep][
                                                                            step.fields[
                                                                            labelIndex
                                                                            ]
                                                                            ] && (
                                                                                <p className="text-red-500 text-sm mt-1">
                                                                                    {
                                                                                        errors[
                                                                                        currentStep
                                                                                        ][
                                                                                        step
                                                                                            .fields[
                                                                                        labelIndex
                                                                                        ]
                                                                                        ]
                                                                                    }
                                                                                </p>
                                                                            )}
                                                                    </div>
                                                                )
                                                            )}
                                                        <p className="font-semibold my-2">
                                                            2. Contrast investigations.
                                                        </p>
                                                        <p className="my-2 font-semibold ">
                                                            For patients above 65 years of age
                                                            or with any known problems with
                                                            kidney function, serum creatinine
                                                            level or eGFR must be available
                                                            prior to imaging.
                                                        </p>
                                                        <div className="flex items-center">
                                                            <p className="me-3">
                                                                Serum creatinine/eGFR reading:{" "}
                                                            </p>
                                                            <input
                                                                type="number"
                                                                name="eGFR"
                                                                value={formData.eGFR || ""}
                                                                onChange={(e) =>
                                                                    handleInputTextChange(
                                                                        "eGFR",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                className="py-2 px-2 border rounded-lg"
                                                            />
                                                        </div>
                                                        <div className="flex items-center mt-2">
                                                            <p className="me-3">Date taken: </p>
                                                            <input
                                                                type="date"
                                                                name="date"
                                                                value={formData.date} // Set default value to an empty string
/*                                                         min={new Date().toISOString().split('T')[0]}
 */                                                        onChange={(e) =>
                                                                    handleInputTextChange(
                                                                        "date",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                className="py-2 px-2 border rounded-lg"
                                                            />
                                                        </div>


                                                        {/* <div className="flex items-center mt-2">
                                                    <p className="me-3">Date taken:<span className="text-red-500">*</span> </p>
                                                    <input
                                                        type="date"
                                                        name="date"
                                                        value={formData.date ? formData.date : ""}
                                                        onChange={(e) =>
                                                            handleInputTextChange(
                                                                "date",
                                                                e.target.value
                                                            )
                                                        }
                                                        className="py-2 px-2 border rounded-lg"
                                                    />
                                                </div> */}
                                                    </>
                                                )}
                                                <div className="flex flex-col my-5">
                                                    {step.stepName === "Safety" && (
                                                        /*  <>
                                                             <p className="font-semibold my-2">3. Pregnancy</p>
                                                             <div className="mb-4 w-1/3">
                                                                 <select
                                                                     name="gender"
                                                                     className="mt-1 p-2 w-full border rounded-md bg-transparent focus:border-sky-blue-700 focus:outline-sky-blue-700 shadow"
                                                                     onChange={(e) =>
                                                                         handleSelectChange("gender", e.target.value)
                                                                     }
                                                                     value={formData.gender || ""}
                                                                 >
                                                                     <option value="" disabled>
                                                                         Select pregnancy status
                                                                     </option>
                                                                     <option value="yes">Yes</option>
                                                                     <option value="no">No</option>
                                                                     <option value="Not applicable">Not applicable</option>
                                                                     <option value="Unknown">Unknown</option>
                                                                 </select>
                                                             </div>
                                                         </> */
                                                        <>
                                                            <p className="font-semibold my-2">3. Pregnancy<span className="text-red-500">*</span></p>
                                                            <div className="mb-4 w-1/3">
                                                                {/* <label className="block text-sm font-medium text-gray-700">
                                                                    Pregnancy
                                                                </label> */}
                                                                <select
                                                                    type="text"
                                                                    name="pregnancyStatus"
                                                                    className="mt-1 p-2 w-full border rounded-md bg-transparent focus:border-sky-blue-700 focus:outline-sky-blue-700 shadow"
                                                                    onChange={handleInputChange}
                                                                    value={formData.pregnancyStatus || ""}
                                                                >
                                                                    <option value="" disabled>
                                                                        Select pregnancy
                                                                    </option>
                                                                    <option value="Yes">Yes</option>
                                                                    <option value="No">No</option>
                                                                    <option value="Not applicable">Not applicable</option>
                                                                    <option value="Unknown">Unknown</option>
                                                                </select>
                                                                {errors.pregnancyStatus && (
                                                                    <p className="text-red-500 text-sm mt-1">
                                                                        {errors.pregnancyStatus}
                                                                    </p>
                                                                )}
                                                                <div
                                                                    className=" mt-4" >
                                                                    <p className="font-semibold my-2">4. Mobility<span className="text-red-500">*</span></p>

                                                                    {/* <label className="block text-sm font-medium text-gray-700">
                                                                        Mobility Status
                                                                    </label> */}
                                                                    <select
                                                                        type="text"
                                                                        name="mobility"
                                                                        onChange={handleInputChange}
                                                                        className="mt-1 p-2 w-full border rounded-md bg-transparent focus:border-sky-blue-700 focus:outline-sky-blue-700 shadow"
                                                                        value={formData.mobility || ""}
                                                                    >

                                                                        <option value="" disabled>
                                                                            Select Mobility
                                                                        </option>
                                                                        <option value="Mobile">Mobile</option>
                                                                        <option value="Non-Mobile">Non-Mobile</option>

                                                                    </select>
                                                                </div>
                                                            </div>

                                                        </>

                                                    )}

                                                    {step.stepName === "Finish" && (
                                                        <div className=" justify-center items-center ">
                                                            <div className="flex justify-center">
                                                                <div className="px-4 py-2 bg-[#003942] text-white rounded-md mt-4">
                                                                    Success!</div>
                                                            </div>

                                                            <div className=" h-full border shadow-lg mb-160px p-6 rounder-2xl text-center mt-2">


                                                                <p className="pb-4">
                                                                    Your referral has been
                                                                    created and a copy has
                                                                    been emailed to you. A confirmation email has also been sent to the patient, our bookings team will be in touch with the patient directly. You
                                                                    can download the PDF
                                                                    referral below or you can
                                                                    find it under your referrals
                                                                    page.
                                                                </p>
                                                                <a
                                                                    href={url}
                                                                    target="_blank"
                                                                    className="px-4 py-2 bg-[#003942] text-white rounded-md mt-4"
                                                                >
                                                                    Download Referral
                                                                </a>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            {step.stepName === "Select Modality" && (
                                                <>
                                                    <div className="flex justify-between gap-6 w-4/5 mt-3 border-1 container">

                                                        {/*  <div className="mb-4 w-1/2">
                                                            <label className="block text-sm font-medium text-gray-700">
                                                                Clinical Indication*
                                                            </label>
                                                            <Textarea
                                                                onChange={(e) =>
                                                                    handleInputTextChange(
                                                                        "clinicalIndication",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                type="text"
                                                                name="clinicalIndication"
                                                                className="mt-1 p-2 w-full border rounded-md bg-transparent focus:border-sky-blue-700 focus:outline-sky-blue-700 shadow"
                                                                placeholder="Please enter any known clinical indication"

                                                            />
                                                            {errors[currentStep] &&
                                                                errors[currentStep][
                                                                step.field
                                                                ] && (
                                                                    <p className="text-red-500 text-sm mt-1">
                                                                        {
                                                                            errors[currentStep][
                                                                            step.field
                                                                            ]
                                                                        }
                                                                    </p>
                                                                )}
                                                        </div> */}
                                                        <div className="mb-4 w-1/2">
                                                            <label className="block text-sm font-medium text-gray-700">
                                                                Clinical Indication*
                                                            </label>
                                                            <Textarea
                                                                onChange={(e) =>
                                                                    handleInputTextChange(
                                                                        "clinicalIndication",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                type="text"
                                                                name="clinicalIndication"
                                                                value={formData.clinicalIndication} // Bind the value here
                                                                className="mt-1 p-2 w-full border rounded-md bg-transparent focus:border-sky-blue-700 focus:outline-sky-blue-700 shadow"
                                                                placeholder="Please enter any known clinical indication"
                                                            />
                                                            {errors[currentStep] &&
                                                                errors[currentStep][
                                                                step.field
                                                                ] && (
                                                                    <p className="text-red-500 text-sm mt-1">
                                                                        {
                                                                            errors[currentStep][
                                                                            step.field
                                                                            ]
                                                                        }
                                                                    </p>
                                                                )}
                                                        </div>

                                                    </div>
                                                </>
                                            )}
                                            <div>
                                                {step.stepName === "Summary" && (
                                                    <>
                                                        <h2 className="block font-none my-2 text-xl text-black-100">
                                                            Modality<span className="text-red-500">*</span>
                                                        </h2>
                                                        <div className="flex mb-0">
                                                            <div className="grid grid-cols-1 gap-2 mt-0 mb-[-12px]">
                                                                {formData.clinicalInfo?.length ? (
                                                                    formData.clinicalInfo.map((items, index) => (
                                                                        <div
                                                                            key={index}
/*                                                                     className={`col-span-1 ${index % 4 === 1 ? 'my-1' : ''} ${index % 4 === 3 ? 'ml-0' : ''} relative overflow-hidden group rounded-lg p-2`}
 */                                                                    className={`col-span-1 ${index % 4 === 1 ? 'my-1' : ''} ${index % 4 === 3 ? 'ml-0' : ''} relative overflow-hidden group rounded-lg p-2`}
                                                                        >
                                                                            <span className="text-gray-500 text-lg">&#8226; </span>
                                                                            <span
                                                                                className="text-gray-700 flex-1"
                                                                            >
                                                                                {items}
                                                                            </span>
                                                                        </div>

                                                                    ))
                                                                ) : (
                                                                    console.error("formData.clinicalInfo is undefined or empty.")
                                                                )}
                                                            </div>




                                                        </div>
                                                        <div className="flex justify-between gap-6 w-4/5 mt-3 container">
                                                            <div className="mb-4 w-1/2">
                                                                <h2 className="block font-none my-2 text-xl text-black-100">
                                                                    Clinical Indication<span className="text-red-500">*</span>
                                                                </h2>
                                                                <input
                                                                    type="text"
                                                                    className="  p-2 pl-0 w-2/3 "
                                                                    value={formData.clinicalIndication}
                                                                    readOnly
                                                                />
                                                                {errors[currentStep] &&
                                                                    errors[currentStep][step.field] && (
                                                                        <p className="text-red-500 text-sm mt-1 font-medium">
                                                                            {errors[currentStep][step.field]}
                                                                        </p>
                                                                    )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {step.stepName === "Summary" && (
                                                    <>
                                                        <p className="my-2 text-xl ">
                                                            1. Safety check (as recommended by
                                                            the MHRA, the referring clinician is
                                                            required to assess patient safety
                                                            for MRI scans).

                                                        </p>
                                                        <p className="my-2 ">
                                                            Cardiac pacemakers, artificial heart
                                                            valves, cochlear implants, cerebral
                                                            aneurysm clips are contra-indicated
                                                            for MRI.
                                                        </p>
                                                    </>
                                                )}

                                                {step.stepName === "Summary" && (
                                                    <>
                                                        {step.labels &&
                                                            (
                                                                <div
                                                                    className="mb-4 "
                                                                >
                                                                    <div className="flex">
                                                                        <label className="block  text-gray-700 flex-1">
                                                                            Does the patient have a metal implant or pacemaker?<span className="text-red-500">*</span>
                                                                        </label>
                                                                        <div className="flex items-center space-x-2">
                                                                            <label className="flex items-center mr-2">
                                                                                <span className="ml-1 py-2 px-2">
                                                                                    {formData.metalImplant}
                                                                                </span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex">
                                                                        <label className="block  text-gray-700 flex-1">
                                                                            Has the patient ever had an injury to the eye involving a metallic object? <span className="text-red-500">*</span>
                                                                        </label>
                                                                        <div className="flex items-center space-x-2">
                                                                            <label className="flex items-center mr-2">
                                                                                <span className="ml-1 py-2 px-2">
                                                                                    {formData.eyeInjury}
                                                                                </span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex items-center mt-2 font-semibold">
                                                                        <p className="me-3 ">Mobility: </p>
                                                                        <span className="ml-1 py-2 px-2 border rounded-lg text-sm font-normal">
                                                                            {formData.mobility}
                                                                        </span>

                                                                    </div>
                                                                    <div className="flex items-center mt-2 font-semibold">
                                                                        <p className="me-3 ">Pregnancy: </p>
                                                                        <span className="ml-1 py-2 px-2 border rounded-lg font-normal ">
                                                                            {formData.pregnancyStatus}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                            )}
                                                        <p className="text-xl my-2 ">
                                                            2. Contrast investigations.
                                                        </p>
                                                        <p className="my-2 text ">
                                                            For patients above 65 years of age
                                                            or with any known problems with
                                                            kidney function, serum creatinine
                                                            level or eGFR must be available
                                                            prior to imaging.
                                                        </p>
                                                        <div className="flex items-center mt-4">
                                                            <p className="me-3 font-semibold">
                                                                Serum creatinine/eGFR reading:{" "}
                                                            </p>
                                                            {formData.eGFR ? (
                                                                <span className="py-2 px-2 border rounded-lg">
                                                                    {formData.eGFR}
                                                                </span>
                                                            ) : null}
                                                        </div>

                                                        <div className="flex items-center mt-2">
                                                            <p className="me-3 font-semibold mt-2">Date taken: </p>
                                                            {formData.date ? (
                                                                <span className="ml-1 py-2 px-2 border rounded-lg">
                                                                    {formatDate(formData.date)}
                                                                </span>
                                                            ) : null}
                                                        </div>

                                                    </>
                                                )}


                                                {/* <div className="flex flex-col my-5">
                                    {step.stepName === "Summary" && (

                                        <>
                                            <p className="font-semibold my-2">3. Pregnancy<span className="text-red-500">*</span></p>
                                            <div className="mb-4 w-1/3">
                                                <label className="block text-sm font-medium text-gray-700">
                                                    Pregnancy Status
                                                </label>
                                                <select
                                                    name="pregnancyStatus"
                                                    className="mt-1 p-2 w-full border rounded-md bg-transparent focus:border-sky-blue-700 focus:outline-sky-blue-700 shadow"
                                                    onChange={(e) => handleSelectChange("pregnancyStatus", e.target.value)}
                                                    value={formData.pregnancyStatus || ""}
                                                >
                                                    <option value="" disabled>
                                                        Select pregnancy status
                                                    </option>
                                                    <option value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                    <option value="Not applicable">Not applicable</option>
                                                    <option value="Unknown">Unknown</option>
                                                </select>
                                                {errors.pregnancyStatus && (
                                                    <p className="text-red-500 text-sm mt-1">
                                                        {errors.pregnancyStatus}
                                                    </p>
                                                )}
                                            </div>
                                        </>

                                    )}
                                </div> */}
                                            </div>


                                            <div className="mt-4 flex justify-end">
                                                {currentStep > 2 &&
                                                    currentStep !== steps.length && (
                                                        <button
                                                            type="button"
                                                            onClick={() => handleEdit(rid)} // Pass rid parameter here
                                                            className="px-4 mx-4 py-2 ml-4 bg-white text-black border border-black rounded-md"
                                                        >
                                                            Edit referral
                                                        </button>


                                                    )}
                                                {/*  {currentStep < steps.length &&
                                    step.stepName === "Select Modality" && (
                                        <div className="mt-4 flex justify-end me-5">
                                            <button
                                                type="button"
                                                onClick={handleCancel}
                                                className="px-4 py-2 bg-[#003942] text-white rounded-md"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                onClick={handleNextStep}
                                                className="px-4 ms-4 py-2 bg-[#003942] text-white rounded-md"
                                            >
                                                Continue to Safety Checks
                                            </button>
                                        </div>
                                    )} */}
                                                {currentStep > 2 &&
                                                    currentStep !== steps.length && (
                                                        <button
                                                            type="button"
                                                            onClick={handleConfirm}
                                                            className="flex px-4 py-2 bg-[#003942] text-white rounded-md pd-30"
                                                        >
                                                            Confirm referral

                                                        </button>
                                                    )}
                                            </div>
                                            <div className="mt-4 flex justify-end">
                                                {currentStep < steps.length &&
                                                    step.stepName === "Safety" && (
                                                        <button
                                                            type="button"
                                                            onClick={handlePreviousStep}
                                                            className="px-4 mx-4 py-2 ml-4 bg-white text-black border border-black rounded-md"
                                                        >
                                                            Previous
                                                        </button>
                                                    )}
                                                {currentStep < steps.length &&
                                                    step.stepName === "Select Modality" && (
                                                        <>
                                                            <div className="mt-4 flex justify-end me-5">
                                                                <button
                                                                    type="button"
                                                                    onClick={handleCancel}
                                                                    className="px-4 py-2 bg-[#003942] text-white rounded-md"
                                                                >
                                                                    Cancel
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={handleNextStep}
                                                                    className=" flex px-4 ms-4 py-2 bg-[#003942] text-white rounded-md"
                                                                >
                                                                    Continue to Safety Checks
                                                                    <div>


                                                                    </div>

                                                                </button>



                                                            </div>

                                                        </>
                                                    )}
                                                {currentStep < steps.length &&
                                                    step.stepName === "Safety" && (
                                                        <button
                                                            type="button"
                                                            onClick={handleSendEmail}
                                                            className=" flex px-4 py-2 bg-[#003942] text-white rounded-md pd-30"
                                                        >
                                                            Proceed to Confirmation


                                                        </button>
                                                    )}
                                            </div>

                                            {/* <div className="mt-4 flex justify-end">
                                {currentStep > 1 &&
                                    currentStep !== steps.length && (
                                        <button
                                            type="button"
                                            onClick={handlePreviousStep}
                                            className="px-4 mx-4 py-2 ml-4 bg-white text-black border border-black rounded-md"
                                        >
                                            Previous
                                        </button>
                                    )}
                                {currentStep < steps.length &&
                                    step.stepName === "Select Modality" && (
                                        <div className="mt-4 flex justify-end me-5">
                                            <button
                                                type="button"
                                                onClick={handleCancel}
                                                className="px-4 py-2 bg-[#003942] text-white rounded-md"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                onClick={handleNextStep}
                                                className="px-4 ms-4 py-2 bg-[#003942] text-white rounded-md"
                                            >
                                                Continue to Safety Checks
                                            </button>
                                        </div>
                                    )}
                                {currentStep < steps.length &&
                                    step.stepName !== "Select Modality" && (
                                        <button
                                            type="button"
                                            onClick={handleSendEmail}
                                            className="px-4 py-2 bg-[#b8c8ca] text-white rounded-md pd-30"
                                        >
                                            Proceed to Final Confirmation
                                        </button>
                                    )}
                            </div> */}
                                        </div>
                                    ))}
                                </form>
                            </div>

                        )}
                </div>
            )}

        </>
    );
};

export default MultiStepForm;
